"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("./factory");
exports.registerElement = factory_1.registerElement;
exports.getElement = factory_1.getElement;
var base_1 = require("./base");
exports.Element = base_1.default;
var factory_2 = require("./factory");
exports.ELEMENT_MAP = factory_2.ELEMENT_MAP;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/index.js
// module id = 597
// module chunks = 37